import $ from "jquery";

const floatLink = function (breakPoint) {
  const $el = $(".js-floatLink") || null;

  // Observer Footer
  var area = document.querySelector(".l-footer");
  var options = {
    rootMargin: "0px",
    threshold: [0],
  };

  const cb = function (entries) {
    entries.forEach(function (entry) {
      if (entry.target.className.match("l-footer")) {
        if (entry.isIntersecting) {
          $el.fadeOut();
        } else {
          $el.fadeIn();
        }
      }
    });
  };
  const observer = new IntersectionObserver(cb, options);
  observer.observe(area);
};

export default floatLink;



// WEBPACK FOOTER //
// ./src/recruit/js/floatLink.js